export default __webpack_public_path__ + "static/media/2_bottom.3658e446.png";